export default {
  mutationRoles(state, payload) {
    state.roles = payload;
  },
  mutationRole(state, payload) {
    state.role = payload;
  },
};
